class DashboardHelpers {
  static formatChartData(chartsData) {
    const labels = chartsData
      ? chartsData.map(item => {
          return item.date;
        })
      : [];

    const data = chartsData
      ? chartsData.map(item => {
          return item.clicks;
        })
      : [];

    return {
      labels,
      data,
    };
  }

  static formatSummaryData(table, summaryData) {
    for (let i = 0; i < table.length; i++) {
      table[i].columns.forEach(item => {
        item.value = summaryData[item.column] || 0;
      });
    }

    return table;
  }
}

export default DashboardHelpers;



// WEBPACK FOOTER //
// ./src/app/main/dashboard/helpers/dashboard-helpers.js